<template>
  <div style="display: grid;">
    <button :id="`view-detail-btn-${transaction.IdTransaction}`" @click="openModal()" class="btn btn-empty btn-open"><i class="fa-light fa-eye"></i></button>
    <b-popover
      :target="`view-detail-btn-${transaction.IdTransaction}`"
      triggers="hover"
      placement="top"
      custom-class="popover-btn"
    >
      View detail
    </b-popover>
    <div class="modal-container" v-if="isModalOpen">
        <div class="modal-content">
          <h1>Reconciliation Details<i @click="closeModal()" class="fa-regular fa-xmark"></i></h1>
          <span style="font-weight: normal; color: #717182;">Complete information for reconciliation {{ 'REC-' + transaction.Lettrage.padStart(6, '0') }}</span>

          <div class="card info-container p-6">
            <div>
              <span style="font-size: 0.9rem; color: #4a5565;">Reference</span>
              <span>{{ 'REC-' + transaction.Lettrage.padStart(6, '0') }}</span>
            </div>
  
            <div>
              <span style="font-size: 0.9rem; color: #4a5565;">Status</span>
              <span class="btn-active"><i class="fa-light fa-circle-check"></i> Active</span>
            </div>
  
            <div>
              <span style="font-size: 0.9rem; color: #4a5565;">Matched By</span>
              <span v-if="transaction.ReconciliationMode == 1" class="btn btn-dark">Automatic</span>
              <span v-else class="btn btn-dark">Manual</span>
            </div>
  
            <div>
              <span style="font-size: 0.9rem; color: #4a5565;">Created</span>
              <span>{{ new Date(transaction.CreationDate).toLocaleString() }}</span>
            </div>
          </div>
          
          <div class="card p-6" style="display: grid; gap: 2rem 0rem;">
            <span style="font-size: 1.25rem; font-weight: bold; display: flex; gap: 0.75rem; align-items: center;"><i style="color: #155dfc; font-size: 1.5rem;" class="fa-light fa-info-circle"></i>Reconciliation Rule Used </span>
            <div style="display: grid;">
              <span style="font-size: 0.85rem;">Rule Name</span>
              <span v-if="transaction.ReconciliationMode == 1" style="font-size: 1.25rem; font-weight: bold;">Auto Reconciliation</span>
              <span v-else style="font-size: 1.25rem; font-weight: bold;">Manual Reconciliation (No Rule)</span>
            </div>
          </div>
          
          <div style="display: flex; justify-content: space-between; gap: 1rem;">
            <div class="card stats">
              <span>Total Orders</span>
              <span style="color: #155dfc; font-weight: bold; font-size: 1.5rem;">€{{ Number(totalOrder).toFixed(2) }}</span>
            </div>
            <div class="card stats">
              <span>Total Payments</span>
              <span style="color: #00a63e; font-weight: bold; font-size: 1.5rem;">€{{ Number(totalPayments).toFixed(2) }}</span>
            </div>
            <div class="card stats">
              <span>Delta</span>
              <span :style="{color: (Number(totalOrder) - Number(totalPayments)) == 0 ? '#4a5565' : '#f54a00', 'font-size': '1.5rem', 'font-weight': 'bold'}">+€{{  Number(delta).toFixed(2).replace('-', '') }}</span>
            </div>
          </div>
          
          <div class="card p-6">
            <span style="font-weight: bold; font-size: 1.25rem;">All Transactions in this Reconciliation ({{ transactions.length }})</span>
            <b-table
              responsive
              class="table-header-border"
              style="margin-bottom:0; margin-top: 2rem;"
              :items="transactions"
              :fields="fields"
              primary-key="id"
            >

            <template #cell(date)="data">
              <div style="display: grid;">
                <span>{{ new Date(data.item.CreationDate).toLocaleDateString() }}</span>
                <span style="color: #6a7282; font-size: 0.85rem;">{{ new Date(data.item.CreationDate).toLocaleTimeString() }}</span>
              </div>
            </template>

            <template #cell(type)="data">
              <span v-if="data.item.Type == 1 && data.item.Direction == 0" class="btn btn-empty" style="display: flex; gap: 0.5rem; align-items: center; justify-content: center; cursor: default; color: #008236; background-color: #f0fdf4; border-color: #b9f8cf;"
              >
                <i class="fa-light fa-credit-card"></i>
                Payment
              </span>

              <span v-else-if="data.item.Type == 0 && data.item.Direction == 1" class="btn btn-empty" style="display: flex; gap: 0.5rem; align-items: center; justify-content: center; cursor: default; color: #1d4ed8; background-color: #eff6ff; border-color: #bfdbfe;"
              >
                <i class="fa-light fa-money-bill"></i>
                Order
              </span>

              <span v-else-if=" data.item.Type == 11 || data.item.Type == 3" class="btn btn-empty" style="display: flex; gap: 0.5rem; align-items: center; justify-content: center; cursor: default; color: #a16207; background-color: #fefce8; border-color: #fef08a;"
              >
                <i class="fa-light fa-money-bill-transfer"></i>
                {{ data.item.Type == 11 ? 'Refund' : data.item.Type == 3 ? 'Credit Note' : '' }}
              </span>

              <span v-else>—</span>
            </template>

            <template #cell(viban)="data">
              <span>{{ data.item.VIBAN }}</span>
            </template>
            

            <template #cell(client)="data">
              <span v-if="data.item.PaymentGroupIdentifier2">{{ data.item.PaymentGroupIdentifier2 }}</span>
              <span v-else>—</span>
            </template>

            <template #cell(reference)="data">
              <span v-if="data.item.InvoiceIdentifier">{{ data.item.InvoiceIdentifier }}</span>
              <span v-else>—</span>
            </template>

            <template #cell(amount)="data">
              <span :style="{'color': data.item.InvoiceType == 'Standard' && data.item.Direction == 0 ? '#00a63e': data.item.InvoiceType == 'Standard' && data.item.Direction == 1 ? 'red' : data.item.Amount >= 0 ? '#00a63e' : 'red' }">
                {{data.item.InvoiceType == 'Standard' && data.item.Direction == 0 ? '+' : data.item.InvoiceType === 'Standard' && data.item.Direction == 1 ? '-': '+'}}€{{Number(data.item.Amount).toFixed(2) }}
              </span>
            </template>

            <template #cell(description)="data">
              <span v-if="data.item.description">{{ data.item.description }}</span>
              <span v-else>—</span>
            </template>

            </b-table>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  name: 'detailTransactionModal',
  props: {
    transaction: Object
  },
  data(){
    return {
      isModalOpen: false,
      fields: [
        {key: 'date', label: 'Date/Time', thClass: 'text-center align-middle border-top border-left border-bottom', tdClass: 'text-left align-middle border-left border-bottom'},
        {key: 'type', label: 'Type', thClass: 'text-center align-middle border-top border-bottom', tdClass: 'text-center align-middle border-bottom'},
        {key: 'viban', label: 'VIBAN', thClass: 'text-center align-middle border-top border-bottom', tdClass: 'text-left align-middle border-bottom'},
        {key: 'client', label: 'Client', thClass: 'text-center align-middle border-top border-bottom', tdClass: 'text-left align-middle border-bottom'},
        {key: 'reference', label: 'Reference', thClass: 'text-center align-middle border-top border-bottom', tdClass: 'text-left align-middle border-bottom'},
        {key: 'amount', label: 'Amount', thClass: 'text-center align-middle border-top border-bottom', tdClass: 'text-left align-middle border-bottom'},
        {key: 'description', label: 'Description', thClass: 'text-center align-middle border-top border-right border-bottom', tdClass: 'text-left align-middle border-right border-bottom'},
      ],
      transactions: [],
      totalOrder: 0,
      totalPayments: 0,
      delta: 0
    }
  },
  methods: {
    openModal (){
      this.isModalOpen = true
      this.$engine.services.payments.getTransactions({Search: this.transaction.VIBAN, GetDetails: 1})
      .then(resp => {
        const data = resp.data
        this.transactions = data.Transactions
        this.totalOrder = Number(data.Transactions.filter(item => item.Direction == 1).reduce((sum, item) => sum + Number(item.Amount), 0))
        this.totalPayments = Number(data.Transactions.filter(item => item.Direction == 0).reduce((sum, item) => sum + Number(item.Amount), 0))
        this.delta = this.totalOrder - this.totalPayments
      })
      .catch(err => {
        console.log(err)
      })
    },
    closeModal (){
      this.isModalOpen = false
    },
  }
}
</script>

<style scoped>
.modal-content{
  overflow-y: scroll;
  max-height: 80vh;
}

.stats>span:first-child{
  color: #4a5565;
  font-size: .85rem;
}

.stats{
  display: grid;
  align-content: space-between;
  padding: 1rem;
}

.info-container{
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1rem;
  background-color: #eff4fc;
  border: 1px solid #bfdbfe;
}

.info-container>div{
  display: grid;
}

.btn-dark{
  background-color: #030213;
  color: #fff;
  cursor: default !important;
  padding: 0;
  min-height: 0;
}

.btn-active{
  color: #008236;
  background-color: #f0fdf4;
  border: 1px solid #b9f8cf;
  cursor: default !important;
  padding: 0;
  padding: 0rem 0.5rem 0rem 0.5rem;
  min-height: 0;
  width: fit-content;
  text-align: left;
  border-radius: var(--borderRadius);
  max-height: 40px;
  font-weight: bold;
}

.btn-open{
  color: #155dfc;
  border: none;
}

.btn-open:hover{
  background-color: #eff6ff;
  color: #1d4ed8;
}
</style>